import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import { Vector3 } from "three";
import {
  DoorGlassMaterial,
  getFrameScaling,
  getGlassPosition,
} from "../../../../../shared/utils/door";

interface GlassProps {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
}

const Glass: React.FC<GlassProps> = ({ doorNodes, materials, index }) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationGlass,
  } = useConfigurationOptionsContext();

  const scaling = getFrameScaling(
    getConfigurationWidth(index),
    getConfigurationHeight(index)
  );

  const position = getGlassPosition(getConfigurationHeight(index));
  const scale = new Vector3(scaling.horizontal.x, scaling.vertical.y, 1);

  return (
    <group>
      {getConfigurationGlass() !== "Helder" && (
        <mesh
          geometry={doorNodes["glass"].geometry}
          material={materials[getConfigurationGlass()]}
          position={position}
          scale={scale}
        />
      )}
    </group>
  );
};

export default Glass;
